import { render, staticRenderFns } from "./ColorComponent.vue?vue&type=template&id=5a16cc93&scoped=true&"
import script from "./ColorComponent.vue?vue&type=script&lang=ts&"
export * from "./ColorComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ColorComponent.vue?vue&type=style&index=0&id=5a16cc93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a16cc93",
  null
  
)

export default component.exports